// chart.js v4 does not register anything by default; react-chartjs-2 relies
// on the host app to register the controllers, scales and elements it uses.
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);
